
import React from 'react'
import { BaseNode } from '../base'
import { NODE_DEFAULTS } from '@genieartinc/schemas'
import type { NodeProps } from '../types'

interface Node3DRequirements {
  promptRequired: boolean
  imageRequired: boolean
}

/** Input requirements per 3D sub-purpose — image-to-3D runs from an image alone */
const SUB_PURPOSE_REQUIREMENTS: Record<string, Node3DRequirements> = {
  'text-to-3d': { promptRequired: true, imageRequired: false },
  'image-to-3d': { promptRequired: false, imageRequired: true },
}

/** Edit models (remesh, retexture…) take a 3D model in, which BaseNode cannot check */
const OPEN_REQUIREMENTS: Node3DRequirements = { promptRequired: false, imageRequired: false }

export function Node3D({ subPurpose, ...props }: Omit<NodeProps, 'config'> & { subPurpose?: string }) {
  const requirements = (subPurpose && SUB_PURPOSE_REQUIREMENTS[subPurpose]) || OPEN_REQUIREMENTS
  return <BaseNode {...props} config={NODE_DEFAULTS['3d']} {...requirements} />
}
